import React, { FC, useMemo } from 'react';
import { localized } from 'shared/state/i18n/i18n';
import { SkioldFormsWrapper } from 'web/view/components/skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { useGeneralSetting } from './general-settings-overview';
import { getNotifyCapacitySows } from './warning-settings';

interface Props {}

export const SowRegistrationSetting: FC<Props> = React.memo(({ ...props }) => {
	const { generalSetting, setGeneralSetting } = useGeneralSetting();

	const rows = useMemo(
		() => [
			{
				header: localized('Registration'),
			},
			getNotifyCapacitySows({ generalSetting, setGeneralSetting }),
		],
		[generalSetting, setGeneralSetting],
	);

	return <SkioldFormsWrapper formRows={rows} containerClassName="wrapper-container" />;
});
